export class CumulativeRainfallIntensity {
  constructor(readonly cumulativeRainfall: number, readonly maxIntensity: number) {}
}
